const AD_SOURCES = [
    "/ads/ad_search_1.png",
    "/ads/ad_search_2.png",
    "/ads/ad_search_3.gif",
    "/ads/ad_search_4.gif",
    "/ads/ad_chat_1.png",
    "/ads/ad_contact.png",
];

const STORAGE_KEY = "ad-banner-order";

function isOriginalNeighbor(left: number, right: number) {
    return Math.abs(left - right) === 1;
}

function shuffle<T>(items: T[]) {
    const next = [...items];
    for (let index = next.length - 1; index > 0; index -= 1) {
        const swapIndex = Math.floor(Math.random() * (index + 1));
        const current = next[index];
        next[index] = next[swapIndex];
        next[swapIndex] = current;
    }
    return next;
}

function neighborCount(order: number[]) {
    let count = 0;
    for (let index = 0; index < order.length - 1; index += 1) {
        if (isOriginalNeighbor(order[index], order[index + 1])) count += 1;
    }
    if (order.length > 1 && isOriginalNeighbor(order[0], order[order.length - 1])) count += 1;
    return count;
}

function buildOnce(length: number) {
    const remaining = shuffle(Array.from({ length }, (_, index) => index));
    const order: number[] = [];
    const first = remaining.shift();
    if (first === undefined) return order;
    order.push(first);

    while (remaining.length > 0) {
        const previous = order[order.length - 1];
        const separated = remaining
            .map((sourceIndex, listIndex) => ({ sourceIndex, listIndex }))
            .filter(({ sourceIndex }) => !isOriginalNeighbor(previous, sourceIndex));
        const pool = separated.length > 0
            ? separated
            : remaining.map((sourceIndex, listIndex) => ({ sourceIndex, listIndex }));
        const picked = pool[Math.floor(Math.random() * pool.length)];
        order.push(picked.sourceIndex);
        remaining.splice(picked.listIndex, 1);
    }

    if (order.length > 2 && isOriginalNeighbor(order[0], order[order.length - 1])) {
        for (let index = 1; index < order.length - 1; index += 1) {
            const candidate = order[index];
            const last = order[order.length - 1];
            const previous = order[index - 1];
            const next = order[index + 1];
            const fitsCycle = !isOriginalNeighbor(order[0], candidate);
            const fitsPrevious = !isOriginalNeighbor(previous, last);
            const fitsNext = !isOriginalNeighbor(next, last);
            if (fitsCycle && fitsPrevious && fitsNext) {
                order[index] = last;
                order[order.length - 1] = candidate;
                break;
            }
        }
    }

    return order;
}

function buildOrder(sources: string[]) {
    let best = buildOnce(sources.length);
    let bestScore = neighborCount(best);

    for (let attempt = 0; attempt < 11 && bestScore > 0; attempt += 1) {
        const candidate = buildOnce(sources.length);
        const score = neighborCount(candidate);
        if (score < bestScore) {
            best = candidate;
            bestScore = score;
        }
    }

    return best.map((index) => sources[index]);
}

function isStoredOrder(value: unknown): value is string[] {
    if (!Array.isArray(value) || value.length !== AD_SOURCES.length) return false;
    const expected = [...AD_SOURCES].sort();
    const actual = [...value].sort();
    return expected.every((src, index) => src === actual[index]);
}

function readStoredOrder() {
    if (typeof window === "undefined") return null;
    try {
        const raw = window.sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed: unknown = JSON.parse(raw);
        return isStoredOrder(parsed) ? parsed : null;
    } catch {
        return null;
    }
}

function persistOrder(order: string[]) {
    if (typeof window === "undefined") return;
    try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(order));
    } catch {
        return;
    }
}

function loadAdOrder() {
    const stored = readStoredOrder();
    if (stored) return stored;
    const order = buildOrder(AD_SOURCES);
    persistOrder(order);
    return order;
}

const adOrder = loadAdOrder();

export function getAdSrc(slotIndex: number) {
    const length = adOrder.length;
    if (length === 0) return "";

    const normalized = ((slotIndex % length) + length) % length;
    if (slotIndex <= 0) return adOrder[normalized];

    const previous = adOrder[(((slotIndex - 1) % length) + length) % length];
    if (adOrder[normalized] !== previous) return adOrder[normalized];
    return adOrder[(normalized + 1) % length];
}
